module.exports = __webpack_public_path__ + "img/carro-feliz.16c19bea.webp";